webpackJsonp([9],{

/***/ 1004:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="20" height="15" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><path d="M0 14.286h20V0H0v14.286zM16.85 1.65l1.054 1.01-4.701 4.506 4.652 4.46-1.054 1.01-4.652-4.46-2.146 2.057L10 10.23l-.002.002L7.85 8.176l-4.653 4.46-1.054-1.01 4.654-4.46L2.096 2.66l1.053-1.01L10 8.216l6.85-6.566z" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _icon_facebook = __webpack_require__(232);

var _icon_facebook2 = _interopRequireDefault(_icon_facebook);

var _icon_twitter = __webpack_require__(233);

var _icon_twitter2 = _interopRequireDefault(_icon_twitter);

var _icon_instagram = __webpack_require__(353);

var _icon_instagram2 = _interopRequireDefault(_icon_instagram);

var _icon_email = __webpack_require__(1004);

var _icon_email2 = _interopRequireDefault(_icon_email);

var _Link = __webpack_require__(103);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'person-intro',
  props: ['nid'],
  components: {
    Facebook: _icon_facebook2.default,
    Twitter: _icon_twitter2.default,
    Email: _icon_email2.default,
    Instagram: _icon_instagram2.default,
    TermLink: _Link2.default
  },
  computed: {
    node: function node() {
      return this.$store.getters.node(this.nid);
    },
    author: function author() {
      return this.$store.getters.term((0, _get2.default)(this, 'node.authors[0]'));
    },
    image: function image() {
      return (0, _get2.default)(this, 'author.images[0].style_square', '');
    },
    title: function title() {
      return (0, _get2.default)(this, 'author.title', '');
    },
    links: function links() {
      var _this = this;

      var links = [];
      if ((0, _get2.default)(this, 'author.links')) {
        var weight = ['facebook', 'twitter', 'instagram', 'email'];
        (0, _forEach2.default)(weight, function (value) {
          if ((0, _get2.default)(_this.author.links, value)) {
            links.push({ type: value, link: (0, _get2.default)(_this.author.links, value) });
          }
        });
      }
      return links;
    },
    bio: function bio() {
      return (0, _get2.default)(this, 'author.bio', false);
    }
  },
  methods: {
    isEmpty: _isEmpty2.default,
    classes: function classes(key) {
      return ['social-icon-' + key];
    }
  }
};

/***/ }),

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".person-intro[data-v-13bbef60]{padding:1.25rem 0;color:#fff;font-family:Barlow,sans-serif;font-size:1rem}.person-intro .thumbnail[data-v-13bbef60]{width:12.5rem;height:12.5rem}.person-intro .introduction[data-v-13bbef60]{background-color:#000;position:relative;margin-bottom:2.3125rem;padding:1.25rem 0;margin:-.625rem auto 2.8125rem;color:#f8008e;width:17.5rem}.person-intro .introduction[data-v-13bbef60]:after{position:absolute;z-index:1;bottom:-2.25rem;left:0;content:\"\";border-top:2.3125rem solid #000;border-right:2.1875rem solid transparent;border-left:0 solid transparent}@media (min-width:1024px){.person-intro .introduction[data-v-13bbef60]{margin:-.625rem auto 3.5625rem}}.person-intro .introduction .authorName[data-v-13bbef60]{font-weight:700;font-size:1.25rem}.person-intro .introduction .social-box[data-v-13bbef60]{width:1.75rem;height:1.75rem;background:#f8008e;border-radius:50%}.person-intro .introduction .social-box~.social-box[data-v-13bbef60]{margin-left:.75rem}.person-intro .introduction .social-box svg[data-v-13bbef60]{height:100%;width:.875rem;display:block;margin:0 auto}.person-intro .introduction .social-box svg.social-icon-facebook[data-v-13bbef60]{width:.4375rem}.person-intro .introduction .intro-text[data-v-13bbef60]{color:#fff;margin-top:-.3125rem}.person-intro .introduction .social-icon path[data-v-13bbef60]{fill:#fff}", "", {"version":3,"sources":["/app/components/common/PersonIntro.vue"],"names":[],"mappings":"AAgCA,+BACE,kBAAmB,AACnB,WAAe,AACf,8BAAkC,AAClC,cAAgB,CACjB,AACD,0CACI,cAAe,AACf,cAAgB,CACnB,AACD,6CACI,sBAA0B,AAC1B,kBAAmB,AACnB,wBAAyB,AACzB,kBAAmB,AACnB,+BAAsC,AACtC,cAAe,AACf,aAAe,CAElB,AACD,mDACM,kBAAmB,AACnB,UAAW,AACX,gBAAiB,AACjB,OAAQ,AACR,WAAY,AACZ,gCAAoC,AACpC,yCAA0C,AAC1C,+BAAiC,CACtC,AACD,0BACA,6CACQ,8BAAsC,CAC7C,CACA,AACD,yDACM,gBAAkB,AAClB,iBAAmB,CACxB,AACD,yDACM,cAAe,AACf,eAAgB,AAChB,mBAAoB,AACpB,iBAAmB,CACxB,AACD,qEACQ,kBAAqB,CAC5B,AACD,6DACQ,YAAa,AACb,cAAgB,AAChB,cAAe,AACf,aAAe,CACtB,AACD,kFACU,cAAiB,CAC1B,AACD,yDACM,WAAe,AACf,oBAAuB,CAC5B,AACD,+DACM,SAAc,CACnB","file":"PersonIntro.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.person-intro[data-v-13bbef60] {\n  padding: 1.25rem 0;\n  color: #FFFFFF;\n  font-family: \"Barlow\", sans-serif;\n  font-size: 1rem;\n}\n.person-intro .thumbnail[data-v-13bbef60] {\n    width: 12.5rem;\n    height: 12.5rem;\n}\n.person-intro .introduction[data-v-13bbef60] {\n    background-color: #000000;\n    position: relative;\n    margin-bottom: 2.3125rem;\n    padding: 1.25rem 0;\n    margin: -0.625rem auto 2.8125rem auto;\n    color: #F8008E;\n    width: 17.5rem;\n    /* Mobile breakpoints */\n}\n.person-intro .introduction[data-v-13bbef60]::after {\n      position: absolute;\n      z-index: 1;\n      bottom: -2.25rem;\n      left: 0;\n      content: '';\n      border-top: solid 2.3125rem #000000;\n      border-right: solid 2.1875rem transparent;\n      border-left: solid 0 transparent;\n}\n@media (min-width: 1024px) {\n.person-intro .introduction[data-v-13bbef60] {\n        margin: -0.625rem auto 3.5625rem auto;\n}\n}\n.person-intro .introduction .authorName[data-v-13bbef60] {\n      font-weight: bold;\n      font-size: 1.25rem;\n}\n.person-intro .introduction .social-box[data-v-13bbef60] {\n      width: 1.75rem;\n      height: 1.75rem;\n      background: #F8008E;\n      border-radius: 50%;\n}\n.person-intro .introduction .social-box ~ .social-box[data-v-13bbef60] {\n        margin-left: 0.75rem;\n}\n.person-intro .introduction .social-box svg[data-v-13bbef60] {\n        height: 100%;\n        width: 0.875rem;\n        display: block;\n        margin: 0 auto;\n}\n.person-intro .introduction .social-box svg.social-icon-facebook[data-v-13bbef60] {\n          width: 0.4375rem;\n}\n.person-intro .introduction .intro-text[data-v-13bbef60] {\n      color: #FFFFFF;\n      margin-top: -0.3125rem;\n}\n.person-intro .introduction .social-icon path[data-v-13bbef60] {\n      fill: #FFFFFF;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1134);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("3d09e888", content, true, {});

/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1145)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1125),
  /* template */
  __webpack_require__(1172),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13bbef60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isEmpty(_vm.author)) ? _c('div', {
    staticClass: "person-intro"
  }, [(!_vm.isEmpty(_vm.image)) ? _c('div', {
    staticClass: "row d-flex justify-content-center"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.image),
      expression: "image"
    }],
    staticClass: "img-fluid thumbnail",
    attrs: {
      "alt": _vm.title
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "introduction"
  }, [_c('div', {
    staticClass: "row justify-content-start pl-3 pr-3 pb-2 no-gutters"
  }, [_c('div', {
    staticClass: "col authorName"
  }, [_c('term-link', {
    attrs: {
      "tid": _vm.author.tid,
      "title": _vm.author.title,
      "url": _vm.author.relative_url,
      "type": _vm.author.type
    }
  }, [_vm._v(_vm._s(_vm.author.title))])], 1)]), (_vm.links) ? _c('div', {
    staticClass: "no-gutters row align-items-start pl-3 pr-3"
  }, _vm._l((_vm.links), function(link) {
    return _c('a', {
      key: link.type,
      staticClass: "social-box",
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_c(link.type, {
      tag: "component",
      staticClass: "social-icon",
      class: _vm.classes(link.type)
    })], 1)
  })) : _vm._e(), (_vm.bio) ? _c('div', {
    staticClass: "row intro-text p-3 "
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        " + _vm._s(_vm.bio) + "\n      ")])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PersonIntro = __webpack_require__(1160);

var _PersonIntro2 = _interopRequireDefault(_PersonIntro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      data: [{ tid: '322292', type: 'author', title: 'Catherine Wong', bio: 'Catherine Wong is a reporter with the South China Morning Post in Beijing, where she focuses on China’s diplomacy and defense policy. Follow her on Twitter @catherinewongbj', links: { twitter: 'http://www.twitter.com/catherinewongbj', email: 'catherine.wong@scmp.com', facebook: 'www.facebook.com', instagram: 'ig.com' }, images: [{ style_140x140: 'https://cdn3.i-scmp.com/sites/default/files/styles/140x140/public/catherine-wong.png?itok=9kAtER2Y', style_square: 'https://cdn1.i-scmp.com/sites/default/files/styles/square/public/catherine-wong.png?itok=tPKOfQRC', full: 'https://cdn3.i-scmp.com/sites/default/files/catherine-wong.png' }], url: 'http://scmpdevuat.scmp.com/author/catherine-wong', relative_url: '/author/catherine-wong' }]
    };
  },

  components: {
    PersonIntro: _PersonIntro2.default
  }
};

/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".person-intro[data-v-f7f0a3dc]{padding:47px}", "", {"version":3,"sources":["/app/pages/IntroView.vue.vue"],"names":[],"mappings":"AAgCA,+BACE,YAAc,CACf","file":"IntroView.vue.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.person-intro[data-v-f7f0a3dc] {\n  padding: 47px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("0ca919dc", content, true, {});

/***/ }),

/***/ 1795:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('person-intro', {
    attrs: {
      "intro": _vm.data
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1637)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1406),
  /* template */
  __webpack_require__(1795),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f7f0a3dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// 9.d0af72b6f10cebef0748.js